var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Button } from '../button';
import translationFallback from '../i18n/translations/en-US/waffles.json';
import { Cross } from '../icon';
import { closeButtonStaticStyle } from './styles';
const sizeMap = {
    large: {
        buttonSize: 'medium',
        iconSize: 'small',
    },
    medium: {
        buttonSize: 'small',
        iconSize: 'xsmall',
    },
};
function CloseButton(_a) {
    var { 'aria-label': ariaLabel, size = 'medium' } = _a, restProps = __rest(_a, ['aria-label', "size"]);
    const { ready, t } = useTranslation('waffles');
    const defaultAriaLabel = ready
        ? t('Shared.close')
        : translationFallback.Shared.close;
    return (_jsx(Button, Object.assign({ "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : defaultAriaLabel, css: closeButtonStaticStyle, icon: _jsx(Cross, { size: sizeMap[size].iconSize }), size: sizeMap[size].buttonSize, variant: "plain" }, restProps)));
}
export default CloseButton;
